import dalton from '../client';
import Authorization from '../constants/Authorization';
import { LegalDocumentObject } from '../constants/LegalDocument';

export type ProfileType = 'ANONYMOUS' | 'ADMIN' | 'AUTHENTICATED';

export interface ChildAccount {
    tid: string;
    nickName: string;
}

export interface UserProfile {
    tid: string;
    profileType: ProfileType;
    firstName: string | null;
    middleName: string | null;
    lastName: string | null;
    birthdate: string | null;
    userEmailResponses: UserEmailResponse[];
    userAddressResponses: UserAddressResponse[];
    userContactNumberResponses: UserContactNumberResponse[];
    userProfileResponses: { adultswim: UserProfileResponse } & Record<string, UserProfileResponse>;
    childAccounts: ChildAccount[];
}

export interface UserAddressResponse {
    id: string;
    description: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    createDate: string;
    lastUpdateDate: string;
}

export interface UserContactNumberResponse {
    id: string;
    contactType: string;
    contactNumber: string;
}

export interface UserEmailResponse {
    emailAddress: string;
    primary: boolean;
}

export interface UserProfileResponse {
    applicationType: string;
    marketingCode: string | null;
    acceptedLegalDocumentResponses: (LegalDocumentObject & { acceptedDate: string })[];
    attributes: Record<string, any>;
    profileStatus: string;
}

export const DO_GET_USER_AUTHORIZATIONS = [Authorization.AUTHN];
export const DO_GET_USER_ENDPOINT = '/core/api/1/user';
export const DO_GET_USER_METHOD = 'GET';

/**
 * Retrieve user information
 *
 * This API allows for either authn or createprofile authorizations. In the case of a federated environment, the user may have registered with another property, and therefore does not have a profile for this property. However, when they arrive on this property, the "profile create" page may need to pre-populate with some existing data ("shared" profile for instance). After the login, the user will only have the createprofile authorization, so we will need to return the user data for that authorization as well as authn
 */
export default async function doGetUser(authorizationHeader: string | null) {
    const resp = await dalton.request<UserProfile>({
        headers: {
            Authorization: authorizationHeader,
        },
        method: DO_GET_USER_METHOD,
        url: DO_GET_USER_ENDPOINT,
    });

    return resp.data;
}
